import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { InlineAlert } from '@/components/feedback';
import { Button, PasswordField, TextField } from '@/components/forms';
import { AuthLayout } from '@/components/layout';
import { safeNext } from './session/RequireAuth';
import { useSession } from './session/context';

/**
 * Login — fiel a design/html/auth.html. Com a auth ligada chama `signIn` (cookie HttpOnly via
 * proxy `/graphql`); em modo demonstração (server sem banco) "Entrar" abre o painel como antes.
 */
export function AuthPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const session = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const next = safeNext(params.get('next'));

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (session.status === 'demo') {
      navigate(next);
      return;
    }
    if (!email.trim() || !password) {
      setError('Informe e-mail e senha.');
      return;
    }
    setBusy(true);
    setError(null);
    const r = await session.signIn(email, password);
    setBusy(false);
    if (r.error) setError(r.error);
    else navigate(next, { replace: true });
  };

  return (
    <AuthLayout badge="Ambiente de teste">
    <form className="auth-card" id="login" noValidate onSubmit={onSubmit}>
      <h2>Acesse sua conta</h2>
      <p className="lead">Gerencie seus pagamentos em um só lugar.</p>
      <TextField id="email" label="E-mail" icon="mail" type="email" placeholder="seu@email.com" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <PasswordField id="pw" label="Senha" placeholder="••••••••" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <div className="forgot"><a href="#" title="Em breve">Esqueci minha senha</a></div>
      {error && <InlineAlert tone="err">{error}</InlineAlert>}
      <Button block type="submit" disabled={busy || session.status === 'loading'}>{busy ? 'Entrando…' : 'Entrar'}</Button>
      <div className="or">ou</div>
      <Button variant="outline-gold" block to="/cadastro">Criar conta</Button>
    </form>
    </AuthLayout>
  );
}
